import { Editor } from '@tinymce/tinymce-react';

import 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/content/default/content.min.css';
import '../../../assets/ext/tinymce/langs/de.js';


export default function RichEditor ({ value, onChange }) {
    return (
        <div>
        <Editor
            value={value}
            onEditorChange={onChange}
            init={{
                license_key: 'gpl',
                menubar: true,
                plugins: 'link code table lists',
                toolbar: 'undo redo | blocks bold italic underline | bullist numlist | link code | table',
                skin: false,
                content_css: false,
                language: 'de',
                language_url: '../../../assets/ext/tinymce/langs/de.js',
            }}
        />
        </div>
    );
}
